import { render } from "./WidgetCustomerOrderMonthly.vue?vue&type=template&id=6559cd3a&scoped=true&ts=true"
import script from "./WidgetCustomerOrderMonthly.vue?vue&type=script&lang=ts"
export * from "./WidgetCustomerOrderMonthly.vue?vue&type=script&lang=ts"

import "./WidgetCustomerOrderMonthly.vue?vue&type=style&index=0&id=6559cd3a&scoped=true&lang=css"

import exportComponent from "/home/uat/uatdan_yrshop_admin/public_html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6559cd3a"]])

export default __exports__